import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Point } from "services/sale/common/types";

interface IMap {
  // Map will be disabled, meaning cant zoom pan or anything
  disabled: boolean;
  // Set the view to map picking
  isPicking: boolean;
  // Open the search part
  isSearching: boolean;
  currentLocation?: Point;
  // The center of map
  tempMarker?: {
    point: Point;
    id?: number;
  };
  // The text address of the point
  address?: string;
  // If pan to terminal area on the map, then this property fill
  area?: string;
  // If pan to terminal area on the map, then this property fill with the area points
  areaPoints?: {
    caption: string;
    id: number;
    point: Point;
  }[];
  // If pan to out of service, then this variable will be true
  isOutofService?: boolean;
  // If editing a destination, then this property contain the editing point info (data before edit)
  isEditing?: any;
  // driverTrackingData
  driverTrackingData?: {
    point: Point;
    direction: number;
  };
}

const initialState: IMap = {
  isPicking: false,
  isSearching: false,
  disabled: true,
  address: "",
  isOutofService: false,
};

const mapSlice = createSlice({
  name: "map",
  initialState: initialState,
  reducers: {
    setDisabled: (state, action) => {
      state.disabled = action.payload;
      return state;
    },
    setIsPicking: (state, action) => {
      state.isPicking = action.payload;
      return state;
    },
    setIsSearching: (state, action) => {
      state.isSearching = action.payload;
      return state;
    },
    setTempMarker: (state, action) => {
      state.tempMarker = action.payload;

      return state;
    },
    setAddress: (state, action) => {
      state.address = action.payload;
      return state;
    },
    setArea: (state, action: PayloadAction<string>) => {
      state.area = action.payload;
      return state;
    },
    setAreaPoints: (state, action: PayloadAction<any>) => {
      state.areaPoints = action.payload;
      return state;
    },
    setIsOutofService: (state, action) => {
      state.isOutofService = action.payload;
      return state;
    },
    reset: (state) => {
      state.isPicking = false;
      state.disabled = true;
      state.address = "";
      state.area = "";
      state.areaPoints = [];
      state.isSearching = false;
      state.isOutofService = false;
      state.tempMarker = null!;
      state.currentLocation = undefined;
      return state;
    },
    flyToLocation: (state, action) => {
      state.tempMarker = action.payload;
      return state;
    },
    setCurrentLocation: (state, action) => {
      state.currentLocation = action.payload;
      return state;
    },
    setDriverTrackingData: (state, action) => {
      state.driverTrackingData = {
        direction: action.payload.direction,
        point: action.payload.point,
      };
      return state;
    },
  },
});

export default mapSlice;
